import { Component, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ScriptsService} from '../../services/scripts.service';
import {SaleService} from '../../services/sale.service';
  import { GoogleAnalyticsService } from '../../../@core/utils/analytics.service';
import {SocketIncome} from '../../services/sockets'
 import * as CryptoJS from 'crypto-js';

// A donation is made in the middle of a broadcast, so it must not move the
// viewer anywhere: the bank's page opens in this modal, and when the money lands
// the modal says thank you and closes itself. The stream underneath never stops.
@Component({
  selector: 'app-payment-donate-modal',
  templateUrl: './payment-donate-modal.component.html',
  styleUrls: ['./payment-donate-modal.component.scss']
})
export class PaymentDonateModalComponent implements OnInit, OnDestroy{

	@Input() stream:any = null

	loading:boolean = true
	// form | paying | waiting | done | failed
	state:string = 'form'
	failMessage:string = ''
	dataLoader$:any = null
	price:number = 0
	sockKey: any = null
	orderId:string = ''
	payUrl:SafeResourceUrl = null
	rawPayUrl:string = ''

	// A payment that goes quiet inside the frame has no error to show: the bank is
	// mid-flow, or a card's 3-D Secure step is refusing to run in a third-party
	// frame, and from the outside both look identical to a blank rectangle. After
	// this long the modal offers the two ways out that do NOT leave the page:
	// paying from the monobank app, or opening the same invoice in its own window.
	private static readonly HELP_AFTER_MS = 100000
	showHelp = false
	private helpTimer:any = null

	private pollTimer:any = null
	private pollDeadline:number = 0
	private messageListener:any = null
	private closeTimer:any = null

	private static readonly POLL_EVERY_MS = 2500
	private static readonly POLL_FOR_MS = 4 * 60 * 1000

	constructor(protected ref: NbDialogRef<PaymentDonateModalComponent>,
	    private socket: SocketIncome,
	    private sanitizer: DomSanitizer,

 public gAnalytics: GoogleAnalyticsService, private saleService: SaleService  ){

		this.sockKey = (new Date().getTime())+''+Math.random()


        }



	ngOnInit(){

		this.loading = false
		this.connectSocket()

		this.messageListener = (event:MessageEvent)=>{
			if(this.handleBankMessage(event)){ return }
			if(event.origin !== window.location.origin){ return }
			const data:any = event.data
			if(!data || data.source !== 'livestream-payment'){ return }
			if(this.state === 'paying'){ this.state = 'waiting'; this.clearHelpTimer() }
		}
		window.addEventListener('message', this.messageListener)

        }

	connectSocket(){
		this.socket.on('cmd', this.onCommand.bind(this))
		this.socket.on('connect', ()=>{
			this.socket.emit('onJoin', {sockKey: this.sockKey})
		})
		this.socket.connect()
	}

	onCommand(data){
		// A donation grants nothing, so the server sends its own event rather than
		// an access code.
		if(data?.type === 'donatePaid'){ this.finish() }
	}


	get priceEncoded(){

           return this.price ? CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.price)) : ''


        }



	pay(){

		if(!this.isPrice){ return }

		this.loading = true

		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}

		this.dataLoader$ = this.saleService
			.createDonateOrder(this.stream?.publicIdentity, this.price, this.sockKey)
			.subscribe((data)=>{

				this.loading = false

				if(!data || !data.ok || !data.pageUrl){
					this.fail(data && data.message)
					return
				}

				this.orderId = data.orderId
				this.rawPayUrl = data.pageUrl
				this.payUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.pageUrl)
				this.state = 'paying'
				this.startPolling()
				this.startHelpTimer()

			}, (err)=>{
				this.loading = false
				this.fail(err?.error?.message)
			})

	}

	private startPolling(){
		this.stopPolling()
		this.pollDeadline = Date.now() + PaymentDonateModalComponent.POLL_FOR_MS

		this.pollTimer = setInterval(()=>{

			if(Date.now() > this.pollDeadline){
				this.stopPolling()
				// Closing silently made the modal simply vanish, which reads as "my money
				// disappeared". Say what happened instead.
				if(this.state !== 'done'){ this.fail(this.isEnglish
					? 'We have not received confirmation of the payment. If money was taken, it has reached the author.'
					: 'Ми не отримали підтвердження оплати. Якщо кошти списано, вони дійшли до автора.') }
				return
			}

			if(!this.orderId){ return }

			this.saleService.getOrderStatus(this.orderId, this.sockKey).subscribe((res)=>{
				if(!res || !res.ok){ return }
				if(res.status === 'reversed'){
					this.fail(this.isEnglish ? 'The payment was returned.' : 'Оплату повернено.')
					return
				}
				if(res.status === 'paid'){ this.finish() }
			}, ()=>{})

		}, PaymentDonateModalComponent.POLL_EVERY_MS)
	}

	private stopPolling(){
		if(this.pollTimer){ clearInterval(this.pollTimer); this.pollTimer = null }
	}

	private startHelpTimer(){
		this.clearHelpTimer()
		this.helpTimer = setTimeout(()=>{
			// Only while still on the bank's form. Once the payment reports back, or
			// fails outright, the hint would be noise.
			if(this.state === 'paying'){ this.showHelp = true }
		}, PaymentDonateModalComponent.HELP_AFTER_MS)
	}

	private clearHelpTimer(){
		if(this.helpTimer){ clearTimeout(this.helpTimer); this.helpTimer = null }
		this.showHelp = false
	}


	// Thanks, then out of the way: there is nothing to collect and the viewer came
	// here to watch, not to read a receipt.
	private finish(){
		this.stopPolling()
		this.clearHelpTimer()
		this.loading = false
		this.state = 'done'
		this.closeTimer = setTimeout(()=>{ this.closeMainModal() }, 3500)
	}

	private fail(message?:string){
		this.stopPolling()
		this.clearHelpTimer()
		this.loading = false
		this.failMessage = message || (this.isEnglish
			? 'Payment is unavailable right now.'
			: 'Оплата зараз недоступна.')
		this.state = 'failed'
	}

	openInWindow(){
		if(!this.rawPayUrl){ return }
		const opened = window.open(this.rawPayUrl.replace('/frame/', '/'), '_blank')
		if(!opened){
			this.failMessage = this.isEnglish
				? 'The browser blocked the payment window. Allow pop-ups for this site, or pay in the form above.'
				: 'Браузер заблокував вікно оплати. Дозвольте спливаючі вікна або оплатіть у формі вище.'
			return
		}
		this.state = 'waiting'
	}

	private handleBankMessage(event:MessageEvent):boolean{
		let bankOrigin = ''
		try { bankOrigin = this.rawPayUrl ? new URL(this.rawPayUrl).origin : '' } catch(e){ bankOrigin = '' }
		if(!bankOrigin || event.origin !== bankOrigin){ return false }
		let data:any = event.data
		if(typeof data === 'string'){
			try { data = JSON.parse(data || '{}') } catch(e){ return true }
		}
		if(!data || typeof data !== 'object'){ return true }
		if(data.message === 'close-button' && this.state === 'paying'){
			this.backToForm()
		}
		if(data.message === 'monopay-link' && typeof data.value === 'string' && /^(https?|monobank):/i.test(data.value)){
			window.location.href = data.value
		}
		return true
	}

	backToForm(){
		this.stopPolling()
		this.clearHelpTimer()
		this.state = 'form'
		this.orderId = ''
		this.payUrl = null
		this.rawPayUrl = ''
	}

    get isEnglish(){

   return ['e017f1c0' , '43de735f' , 'aada46cb' , 'ccfabee3','0432f141','0bbac3f1', '0d29511e', '8ab1af07', 'ced3e648','a7b77c92', '7900e957'].includes(this.stream.publicIdentity)

  }

	get isPrice() {

		return this.price >= 10
	}


	closeMainModal(){
		this.ref.close()

	}






	ngOnDestroy(){
		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}

		this.stopPolling()
		this.clearHelpTimer()
		if(this.closeTimer){ clearTimeout(this.closeTimer); this.closeTimer = null }

		if(this.messageListener){
			window.removeEventListener('message', this.messageListener)
			this.messageListener = null
		}

		this.socket.disconnect()
		this.socket.removeAllListeners('cmd')
		this.socket.removeAllListeners('connect')
	}



}
